import React, { useState } from 'react'
// @ts-ignore no types
import _, { isFunction } from 'lodash'
// @ts-ignore no types
import { connect } from 'react-redux'
import _cx from 'classnames/bind'
import {
  Accordion,
  Divider,
  Grid,
  Icon,
  List,
  Text,
  useApplicationContext,
  // @ts-ignore no types
} from '@adc/ui-adc'
import * as graph from '@adc/sdk'
import * as blueprint from '@adc/blueprint'
import type { Maybe, AuctionSegment } from '@adc/sdk/types'
import { contactNumbers } from '@adc/constants'
import { formatPhoneNumber } from 'common/utils/formatters'
import AdvertisementInjection from 'common/components/advertisement/advertisementInjection'
import { useListingContext } from '../../context/listing'
import { shouldShowSealedBidTreatment } from '../../utils/privateSeller'
// @ts-ignore no types
import HelpCenterImage from '../../images/helpcenter.png'
import SectionPanel from '../../components/sectionPanel'
// @ts-ignore no types
import Checklist from './contracting-checklist.pdf'
// @ts-ignore no types
import cls from './index.scss'
const cx = _cx.bind(cls)

// TODO The asset type def needs to be part of BluePrint listing utils
// TODO update Listing param to be overloadable with respect to mounted online or live reactive argument Please refer to  https://github.com/auctioncorp/mobile-react-native/blob/d741cab943ae1b81d1ce98960a06d6a3cf475be8/src/components/ListingCard/Secondary/utils.ts#L107
const isNotFcl = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
): boolean => {
  return (
    listing.listing_configuration?.asset_type !==
    graph.enums.AssetType.Foreclosure
  )
}

const isTPSLive = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
): boolean =>
  listing.listing_configuration?.asset_type ===
    graph.enums.AssetType.Foreclosure &&
  !listing.auction?.is_online &&
  listing?.listing_configuration?.product_type !==
    graph.enums.ProductType.FclMarketing

const isTPSOhio = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
): boolean =>
  Boolean(blueprint.listing.utils.isFclOnlineAuction(listing)) &&
  listing.seller_property?.country_primary_subdivision === 'OH'

const isTPSIllinois = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
): boolean =>
  Boolean(blueprint.listing.utils.isFclOnlineAuction(listing)) &&
  listing.seller_property?.country_primary_subdivision === 'IL'

const isTennessee = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
): boolean =>
  Boolean(blueprint.listing.utils.isFclOnlineAuction(listing)) &&
  listing.seller_property?.country_primary_subdivision === 'TN'

const isFCLMarketing = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
): boolean =>
  listing.listing_configuration?.product_type ===
  graph.enums.ProductType.FclMarketing

const isTPSCalifornia = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
): boolean =>
  listing.listing_configuration?.asset_type ===
    graph.enums.AssetType.Foreclosure &&
  !listing.auction?.is_online &&
  listing.seller_property?.country_primary_subdivision === 'CA'

const isOffer = (
  segment: Maybe<
    | AuctionSegment
    | blueprint.AuctionBlueprintScheduledOnlineReactiveArgs['segment']
    | blueprint.AuctionBlueprintLiveReactiveArgs['segment']
  >,
  featureFlags?: any
): boolean => shouldShowSealedBidTreatment({ segment, featureFlags })

const isPrivateSeller = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
): boolean =>
  listing.listing_configuration?.asset_type ===
  graph.enums.AssetType.PrivateSeller

const isSmartSale = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
): boolean =>
  _.get(listing, 'listing_configuration.product_type', '') ===
  graph.enums.ProductType.PrivateSeller

interface Contents {
  elmId: string
  condition?: (
    listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
  ) => boolean
  q: string
  a: React.ReactNode
}

const getContents = (): Contents[] => {
  const { segment, listing } = useListingContext()
  const { featureFlags } = useApplicationContext()
  const isOfferContent = isOffer(segment, featureFlags)
  const isReoAuction =
    listing.listing_configuration?.asset_type ===
      graph.enums.AssetType.BankOwned && !isOfferContent
  const showGenericEmdCopy =
    isReoAuction && featureFlags['fe.resi.pdp.enable_pdp_emd_instructions']
  const noneOfferContents = [
    {
      elmId: 'inspect',
      condition: () => isNotFcl(listing),
      q: 'Will I be able to inspect the property before I bid?',
      a: 'Typically, no. Many properties will be sold "as is, where is," with all faults and limitations. You\'ll need to estimate any renovation costs from a distance. Even if you believe the home is vacant, treat it as occupied. These homes have not transferred ownership yet and walking on or entering the property is trespassing.',
    },
    {
      elmId: 'more_info',
      condition: () => isNotFcl(listing),
      q: 'Does Auction.com have any more information on this property?',
      a: (
        <>
          <p>
            Like other real estate transactions, you should conduct careful due
            diligence before purchasing a property at auction. Common research
            items include local market value, property condition, and title
            report.
          </p>
          <p>
            Please note, Auction.com is not the seller for any property made
            available online, and all information and photos to Auction.com have
            been made available on this page.
          </p>
        </>
      ),
    },
    {
      elmId: 'liens',
      condition: () => isNotFcl(listing),
      q: 'Will the property be free and clear of all liens?',
      a: 'Not necessarily. You should seek independent advice to perform your own due diligence and fully understand the foreclosure process and foreclosure sales in general. It is your responsibility to do a title search and seek any professional counsel before bidding.',
    },
    {
      elmId: 'financing',
      condition: () => isNotFcl(listing),
      q: 'Can I use financing to buy this property?',
      a: 'Typically, no. Be sure to check the property listing to see if financing is considered. Most properties on Auction.com are sold cash-only. That means you must pay the entire purchase amount by the closing date.',
    },
    {
      elmId: 'winning_bidder',
      condition: () => isNotFcl(listing),
      q: 'What happens if I am the winning bidder?',
      a: (
        <>
          <p>
            If you are the highest bidder at the end of an auction, here are
            your post-auction obligations:
          </p>
          <ol>
            <li className='u-mb-2'>
              <b>Contract Information:</b> You'll receive an email confirming
              you have the highest bid. You will then need to provide important
              contracting information by filling out a form online. You can{' '}
              <a href={Checklist} target='_blank' rel='noreferrer'>
                preview the required information on this form as a printable
                checklist
              </a>
              . Make sure to submit the form within <b>1 business day</b>.
            </li>
            <li className='u-mb-2'>
              <b>Purchase Agreement:</b> Once everything is verified, the
              Purchase Agreement will be generated and you will need to sign and
              return the document for the seller to review and sign.
            </li>
            <li className='u-mb-2'>
              <b>Proof of Funds:</b> You need to provide Auction.com a copy of
              your Proof of Funds by email within <b>2 business days</b>.
            </li>
            <li>
              <b>Earnest Money Deposit:</b>{' '}
              {showGenericEmdCopy ? (
                "You'll need to send your Earnest Money Deposit to the closing company and upload a copy of your confirmation receipt to Auction.com. Timing and amount vary by property, so check your purchase agreement for the exact details."
              ) : (
                <>
                  Unless otherwise specified on your purchase agreement, you
                  will need to send the Earnest Money Deposit to the closing
                  company within <b>2 business days</b> of receiving the
                  transfer instructions. Send Auction.com a copy of your
                  confirmation receipt within <b>1 business day</b> of sending
                  funds.
                </>
              )}
            </li>
          </ol>
        </>
      ),
    },
    {
      elmId: 'subject_to_redemption',
      condition: (
        listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
      ) =>
        listing?.listing_configuration?.product_type ===
        graph.enums.ProductType.Redemption,
      q: 'What does "Subject to Redemption" mean?',
      a: (
        <>
          <p>
            Per state law, there is a period when certain parties have the
            opportunity to "redeem" a foreclosed property.
          </p>
          <p>
            You can't collect rent or obtain possession until the redemption
            period is over.
          </p>
          <p>
            If the property is redeemed, you will receive only the amount paid
            to redeem the property. Please research the amount before bidding as
            it may be less than the winning bid.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_auction_work',
      condition: () => isTPSLive(listing),
      q: 'How does a foreclosure auction work?',
      a: (
        <>
          <p>
            The foreclosure process starts when a homeowner stops paying their
            mortgage. The lender sends the homeowner a notice, giving them a
            period of time to pay, or the property goes to auction. The
            homeowner can take steps to either postpone or cancel the auction.
            At the auction, the bank won't bid more than the credit bid.
          </p>
          <p>
            The purchaser at the auction is essentially paying off the mortgage
            and is responsible for any additional liens attached to the
            property. If no one bids above the credit bid, the property goes
            back to the bank. And, it becomes a real-estate owned (REO) property
            for sale.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_access',
      condition: () => isTPSLive(listing),
      q: 'Can I get inside or visit the property before the auction?',
      a: (
        <>
          <p>
            Interior access is not available for any property sold at a
            foreclosure auction. All foreclosed properties are sold as is, where
            is.
          </p>
          <p>
            You'll need to estimate any repair or upgrade costs from a distance.
            Even if you think the home is vacant, treat it as occupied. These
            homes have not transferred ownership yet. So, walking on or entering
            the property is trespassing and a crime.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_how_much_to_bring',
      condition: () => isTPSLive(listing),
      q: `If I don't know how much the property will sell for, how do I know how much to bring?`,
      a: (
        <>
          <p>
            All counties have different payment requirements. Some require the
            full amount of the winning bid at the sale. Others only need a
            deposit and the balance is due at a later date.
          </p>
          <p>
            Generally, payment is required in the form of cashier's check at the
            auction. Be sure you know your maximum budget when preparing for the
            auction. Some investors bring multiple checks in different
            denominations. This allows them to get the payment as close to the
            bid as possible. If you bring more than the winning bid, you will be
            sent a check from the trustee for the difference.
          </p>
          <p>
            Keep in mind you will only be able to bid up to the amount you
            brought. You will not be allowed to go to the bank for more funds.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_county',
      condition: () => isTPSLive(listing),
      q: 'I thought foreclosure properties are auctioned by the county. Why is Auction.com involved in this sale?',
      a: (
        <>
          <p>Foreclosure properties are sold a couple different ways.</p>
          <ol>
            <li>
              In some states, Auction.com is appointed by the foreclosure
              attorney to conduct the sale.
            </li>
            <li>
              In other states, the sale is done by a court-appointed official
              (usually the sheriff).
            </li>
          </ol>
          <p>
            Auction.com often lists properties auctioned by the county. We do
            this to provide you with a wide range of options for your next
            investment.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_financing',
      condition: () => isTPSLive(listing),
      q: 'Can I use financing to buy this property?',
      a: (
        <>
          <p>
            Most mortgage lenders want a property inspection or appraisal. So,
            they won't provide loans on occupied properties.
          </p>
          <p>
            These properties are sold as-is and without interior access. You
            must pay the full amount with a cashier's check. Make sure you check
            the property page for specific details on fund requirements.
          </p>
          <p>
            Some investors use other sources to get cashier's checks. These can
            include hard-money loans or lines of credit. But, to use one of
            these types of loans, the loan can't require property inspections or
            appraisals.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_online_ohio_differences',
      condition: () => isTPSOhio(listing),
      q: 'What is the difference between an in-person foreclosure sale and an online foreclosure sale?',
      a: (
        <>
          <p>Ohio offers two types of foreclosure sales:</p>
          <ol>
            <li>
              The sheriff runs in-person foreclosure sales, also known as a
              sheriff sale. These take place at the courthouse.
            </li>
            <li>
              A court-appointed private selling officer (PSO) conducts
              foreclosure sales.
            </li>
          </ol>
          <p>
            The properties sold at these two types of auctions are all in the
            same stage of the{' '}
            <a
              href='/lp/foreclosure/oh/#how-to-buy'
              target='_blank'
              rel='noreferrer'
            >
              foreclosure process
            </a>
            . At both sales, a third-party bidder buys the property or it
            reverts to the lender. When it reverts, it becomes a real estate
            owned (REO) or bank-owned property. Auction.com lists properties for
            auction at either of these sales.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_online_ohio_tutorial',
      condition: () => isTPSOhio(listing),
      q: 'How do I take part in an online foreclosure sale?',
      a: (
        <>
          <p>
            Registration is required for each property you wish to bid on in an
            Auction.com online foreclosure sale. This simple process only
            requires a free Auction.com account and a credit or debit card to
            place a bid deposit hold (usually $100). This hold is required to
            verify your identity and maintain the integrity of the auction. Your
            card will not be charged. The hold will be released after the
            auction is completed.
          </p>
          <p>
            Once these steps are taken, you will be authorized to bid and may
            place a bid once the auction is opened. This hold is required to
            verify your identity and maintain the integrity of the auction. Your
            card will not be charged. The hold will be released after the
            auction is completed.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_online_ohio_identify',
      condition: () => isTPSOhio(listing),
      q: 'How do I know which Ohio properties on your site are being auctioned live and which ones are being auctioned online?',
      a: 'The easiest way to tell the difference between the two is to look at the property page. A label at the top of the page shows if the property is available for an online auction or an in-person auction. In-person auctions show the address for where the sale will take place.',
    },
    {
      elmId: 'foreclosure_online_ohio_interior_access',
      condition: () => isTPSOhio(listing),
      q: 'Can I get inside or visit the property before the auction?',
      a: (
        <>
          <p>
            Interior access is not available for any property sold at a
            foreclosure auction. All foreclosed properties are sold as is, where
            is.
          </p>
          <p>
            You'll need to estimate any repair or upgrade costs from a distance.
            Even if you think the home is vacant, treat it as occupied. These
            homes have not transferred ownership yet. So, walking on or entering
            the property is trespassing and a crime.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_online_ohio_highest_bidder',
      condition: () => isTPSOhio(listing),
      q: 'What happens if I am the highest bidder?',
      a: (
        <>
          <p>
            If you are the highest bidder at the end of an auction, here is what
            you need to know.
          </p>
          <ol>
            <li>
              <strong>Contract Information:</strong> You'll receive an email
              confirming you have the highest bid. You must provide important
              contracting information by filling out an online form.{' '}
              <a
                href='//image.adc.auction.com/lib/fe391570756404787c1774/m/1/4c57c416-2f42-473a-829b-89037e49d13a.pdf'
                target='_blank'
                rel='noreferrer'
              >
                Preview the required information as a printable checklist
              </a>
              . Submit the form within 1 business day
            </li>
            <li>
              <strong>Purchase Agreement:</strong> Once everything is verified,
              you'll receive the Purchase Agreement via DocuSign. Sign and
              return the document within 2 business days so the seller can
              review and sign.
            </li>
            <li>
              <strong>Proof of Funds:</strong> Provide Auction.com a copy of
              your Proof of Funds by email within 2 business days.
            </li>
            <li>
              <strong>Earnest Money Deposit:</strong> Wire instructions are
              provided on the first page of the Purchase Agreement.
            </li>
          </ol>
          <p>
            Unless otherwise specified, send your Earnest Money Deposit to the
            closing company within 2 business days. Send Auction.com a copy of
            your confirmation receipt.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_online_florida_website',
      condition: () => isFCLMarketing(listing),
      q: 'Why was I sent to another website when I tried to bid?',
      a: 'Online foreclosure auctions are managed by each county and bidding takes place on individual county websites.',
    },
    {
      elmId: 'foreclosure_online_florida_website',
      condition: () => isFCLMarketing(listing),
      q: 'If the counties operate their own websites, why do I need to use Auction.com?',
      a: `Auction.com provides a central location for information on foreclosure sales across the entire state. This gives you easy access to information you won't find anywhere else.`,
    },
    {
      elmId: 'foreclosure_online_florida_website',
      condition: () => isFCLMarketing(listing),
      q: 'Do I have to register to bid separately for each county?',
      a: `Usually, once you create your login account, you're ready to bid in most counties. Some counties may use a different foreclosure system than the other counties. Check the county website for more information.`,
    },
    {
      elmId: 'foreclosure_online_florida_website',
      condition: () => isFCLMarketing(listing),
      q: 'How do I know which properties are auctioned in-person and which ones are auctioned online?',
      a: 'The easiest way to tell the difference between the two is to look at the property page. A label at the top of the page tells you if the property is available for an online auction on the county website or an in-person auction. In-person auctions show the address for where the sale will take place. Check the county website for updated information for the date, time and location of the auction.',
    },
    {
      elmId: 'foreclosure_online_florida_website',
      condition: () => isFCLMarketing(listing),
      q: 'Can I get inside or visit the property before the auction?',
      a: (
        <>
          <p>
            Interior access is not available for any property sold at a
            foreclosure auction. All foreclosed properties are sold{' '}
            <strong>as is, where is.</strong>
          </p>
          <p>
            Even if you think the home is vacant, treat it as occupied. These
            homes have not transferred ownership yet. So, walking on or entering
            the property is trespassing and a crime.
          </p>
        </>
      ),
    },
    {
      elmId: 'foreclosure_california',
      condition: () => isTPSCalifornia(listing),
      q: 'What is Senate Bill 1079 and how does it relate to this property?',
      a: (
        <>
          <p>
            Beginning January 1, 2021, California law requires a post-auction
            sale opportunity for qualifying bidders, such as: a current tenant,
            a qualifying government entity, certain non-profits, and prospective
            owner-occupants.
          </p>
          <p>
            If an owner-occupant is the winning bidder at the foreclosure sale
            and is able to provide funds and sign an affidavit at the point of
            sale, the sale will finalize immediately.
          </p>
          <p>
            If the winning bidder at the foreclosure sale is not a prospective
            owner-occupant, they have to wait 15 days to see if an eligible
            bidder or eligible tenant will submit an intent to bid. If no intent
            to bid comes through, the sale will finalize after 15 days.
          </p>
          <p>
            If an eligible bidder submits an intent to bid within those 15 days,
            they will have 45 days from the date of the sale to submit their
            funds. If there was a bidder at the sale, they will receive a return
            of the funds paid.
          </p>
          <p>
            Find properties recently sold at our Foreclosure auctions in
            California{' '}
            <a href='/sb1079' target='_blank' rel='noreferrer'>
              here
            </a>
            .
          </p>
        </>
      ),
    },
  ]
  const offerContents = [
    {
      elmId: 'privateseller_see_inside',
      condition: () => isOffer(segment, featureFlags),
      q: 'Can I see inside?',
      a: (
        <>
          <ol>
            <li className='u-mb-2'>
              Most sellers will allow you to set up a convenient time to visit.
            </li>
            <li className='u-mb-2'>
              Always obtain proper permission and follow all applicable laws and
              regulations when viewing properties.
            </li>
            <li className='u-mb-2'>
              Even where you may not be allowed inside prior to offer, interior
              photos and videos may be available for your review to conduct your
              due diligence.
            </li>
          </ol>
        </>
      ),
    },
    {
      elmId: 'privateseller_make_offer',
      condition: () => isOffer(segment, featureFlags),
      q: 'I’m ready to make an offer, now what?',
      a: (
        <>
          <p>Click the button and we'll guide you step by step.</p>
        </>
      ),
    },
    {
      elmId: 'privateseller_my_offer',
      condition: () => isOffer(segment, featureFlags),
      q: 'What happens after my offer?',
      a: (
        <>
          <p>We'll notify you right away when the seller responds.</p>
        </>
      ),
    },
    {
      elmId: 'privateseller_inspection',
      condition: () => isOffer(segment, featureFlags),
      q: 'Can I get it inspected?',
      a: (
        <>
          <p>
            In most cases, yes! After offer acceptance, you can have a
            professional conduct a thorough inspection.
          </p>
        </>
      ),
    },
  ]

  const smartSaleAuctionContents = [
    {
      elmId: 'smartsale_inspect',
      condition: () => isNotFcl(listing),
      q: 'Will I be able to see the interior of the house, or inspect the property before I bid?',
      a: 'Please check on this page for any mentioning of Open Houses, Private Tours available, or Inspection Contingency accepted. If none of these are available, you shall assume that you will not be able to see the interior of the house, and you are not entitled to an inspection prior to bidding.',
    },
    {
      elmId: 'smartsale_financing',
      condition: () => isNotFcl(listing),
      q: 'Can I use financing to buy this property?',
      a: 'Typically, no. Be sure to check the property listing to see if financing is considered. Most properties on Auction.com are sold cash-only. That means you must pay the entire purchase amount by the closing date.',
    },
    {
      elmId: 'smartsale_more_info',
      condition: () => isNotFcl(listing),
      q: 'Does Auction.com have any more information on this property?',
      a: (
        <>
          <p>
            You may contact the listing agent directly. Their contact
            information is typically displayed on the property's listing page.
          </p>
        </>
      ),
    },
    {
      elmId: 'smartsale_liens',
      condition: () => isNotFcl(listing),
      q: 'Will the property be free and clear of all liens?',
      a: "Private Seller properties are typically offered with clear title. However,  it's the buyer's responsibility to do their own due diligence like a title search and talk to a professional to check for any debts or issues before bidding.",
    },
    {
      elmId: 'smartsale_winning_bidder',
      condition: () => isNotFcl(listing),
      q: 'What happens if I am the winning bidder?',
      a: (
        <>
          <p>
            If you are the highest bidder at the end of an auction, here are
            your post-auction obligations:
          </p>
          <ol>
            <li className='u-mb-2'>
              <b>Contract Information:</b> You'll receive an email confirming
              you have the highest bid. You will then need to provide important
              contracting information by filling out a form online. You can{' '}
              <a href={Checklist} target='_blank' rel='noreferrer'>
                preview the required information on this form as a printable
                checklist
              </a>
              . Make sure to submit the form within <b>1 business day</b>.
            </li>
            <li className='u-mb-2'>
              <b>Purchase Agreement:</b> Once everything is verified, the
              Purchase Agreement will be generated and you will need to sign and
              return the document for the seller to review and sign.
            </li>
            <li className='u-mb-2'>
              <b>Proof of Funds:</b> You need to provide Auction.com a copy of
              your Proof of Funds by email within <b>2 business days</b>.
            </li>
            <li>
              <b>Earnest Money Deposit:</b> Unless otherwise specified on your
              purchase agreement, you will need to send the Earnest Money
              Deposit to the closing company within <b>2 business days</b> of
              receiving the transfer instructions. Send Auction.com a copy of
              your confirmation receipt within <b>1 business day</b> of sending
              funds.
            </li>
          </ol>
        </>
      ),
    },
  ]

  const smartSaleOfferContents = [
    {
      elmId: 'smartsale_prepare',
      condition: () => isOffer(segment, featureFlags),
      q: 'How do I prepare to make an offer?',
      a: (
        <>
          <p>
            Make sure you know your budget and what you're willing to spend.
            Having your proof of funds ready in advance will help ensure a
            smooth and credible offer submission.
          </p>
        </>
      ),
    },
    {
      elmId: 'smartsale_financial_docs',
      condition: () => isOffer(segment, featureFlags),
      q: 'Why do I need to upload financial documentation?',
      a: (
        <>
          <p>
            This ensures that you are financially prepared to complete the
            transaction. Your documentation must match the full offer amount to
            verify your ability to proceed with the purchase.
          </p>
        </>
      ),
    },
    {
      elmId: 'smartsale_change_offer',
      condition: () => isOffer(segment, featureFlags),
      q: 'Can I change my offer after submission?',
      a: (
        <>
          <p>
            Yes! You can update your offer anytime before the review deadline.
            However, keep in mind that sellers can accept an offer at any time,
            so always ensure your best offer is submitted. During the Seller
            Decision Period of the Highest & Best Round, offers can no longer be
            updated.
          </p>
        </>
      ),
    },
    {
      elmId: 'smartsale_need_agent',
      condition: () => isOffer(segment, featureFlags),
      q: 'Do I need an agent to submit an offer?',
      a: (
        <>
          <p>
            Buyers are not required to have an agent to submit an offer.
            However, you should seek any professional assistance appropriate for
            your situation. The Listing Agent will prepare the contract for your
            signature.
          </p>
        </>
      ),
    },
    {
      elmId: 'smartsale_specific_questions',
      condition: () => isOffer(segment, featureFlags),
      q: 'What if I have other specific questions about this property?',
      a: (
        <>
          <p>
            You may contact the listing agent directly. Their contact
            information is typically displayed on the property's listing page.
          </p>
        </>
      ),
    },
  ]

  const illinoisOnlineContents = [
    {
      elmId: 'illinois_online_online_live_difference',
      q: 'What is the difference between online sales and a live sale?',
      a: (
        <p>
          In Illinois, foreclosure sales can take place either live or online.
          There is no difference in the types of Properties offered at these
          auctions. All are at the same stage in the foreclosure process. In
          both sales, the Property is either sold to a third-party bidder or
          reverts to the Plaintiff (Bank or Lender). <br /> For the most
          accurate and up-to-date details, refer to the Foreclosure Sale Notice,
          or visit our website at{' '}
          <a href='https://auction.com' target='_blank' rel='noreferrer'>
            www.auction.com
          </a>{' '}
          Or call our office directly at{' '}
          <a
            href={`tel:${contactNumbers.IL_ONLINE_SUPPORT_NUMBER}`}
            target='_blank'
            rel='noreferrer'
          >
            {formatPhoneNumber(contactNumbers.IL_ONLINE_SUPPORT_NUMBER)}
          </a>
        </p>
      ),
    },
    {
      elmId: 'illinois_online_liens',
      q: 'Will the Property be free and clear of all liens?',
      a: (
        <p>
          Typically, no. Many Properties will be sold “as is, where is,” with
          all faults and limitations. All prospective bidders are encouraged to
          conduct their own due diligence and investigate all matters relating
          to the Properties that they are interested in purchasing. It is
          recommended that you seek independent advice to perform your due
          diligence and to fully understand the foreclosure process and
          foreclosure sales in general prior to the sale. Doing your homework
          pays off! Some Properties may have information provided by Auction.com
          on the Property details page. It is your responsibility to do a title
          search and seek any needed advice from counsel prior to the sale.
        </p>
      ),
    },
    {
      elmId: 'illinois_online_inspection',
      q: 'Can I inspect the Property?',
      a: (
        <p>
          No, as these Properties can be occupied, prospective bidders may not
          trespass on the Property, disturb the occupants or contact the
          borrowers to obtain information about the Property. However, detailed
          Property information for some Properties may be available for
          informational purposes only on the Property details page at
          Auction.com
        </p>
      ),
    },
    {
      elmId: 'illinois_online_winning_bidder',
      q: 'What happens after I win?',
      a: (
        <p>
          Live in-person Auction: Bidder must provide a Cashier’s Check or
          Certified Check for 20% of your highest intended bid, made out to
          Auction.com, LLC. The remaining amount must be received in 24 hours
          from sales time. <br /> Online Auction: After the closing of sale, a
          representative from Auction.com will contact you to finalize all
          paperwork and provide instructions for transferring funds, which must
          be received within 24 hours of the sale.
        </p>
      ),
    },
    {
      elmId: 'illinois_online_deed_of_sale',
      q: 'Will I receive a deed of sale?',
      a: (
        <p>
          Yes, in Illinois, the deed will be prepared and mailed within 10 days
          of receiving the court’s order approving the sale. Based on the
          judge’s docket and the county, the court order approving sale
          typically takes 30 to 90 days from the sale date
        </p>
      ),
    },
  ]

  const tennesseeOnlineContents = [
    {
      elmId: 'tennessee_online_online_live_difference',
      q: 'What is the difference between online sales and a live sale?',
      a: (
        <>
          <p>
            In Tennessee, foreclosure sales can take place either live or
            online. There is no difference in the types of Properties offered at
            these auctions. All are at the same stage in the foreclosure
            process. In both sales, the Property is either sold to a third-party
            bidder or reverts to the Plaintiff (Bank or Lender).
          </p>
          <p>
            For the most accurate and up-to-date details, refer to the
            Foreclosure Sale Notice, or visit our website at&nbsp;
            <a href='https://auction.com' target='_blank' rel='noreferrer'>
              www.auction.com
            </a>
            &nbsp; Or call our office directly at&nbsp;
            <a
              href={`tel:${contactNumbers.IL_ONLINE_SUPPORT_NUMBER}`}
              target='_blank'
              rel='noreferrer'
            >
              {formatPhoneNumber(contactNumbers.IL_ONLINE_SUPPORT_NUMBER)}
            </a>
          </p>
        </>
      ),
    },
    {
      elmId: 'tennessee_foreclosure_sale_process',
      q: 'What is the foreclosure sale process in Tennessee?',
      a: (
        <p>
          A foreclosure sale is conducted via a public sale that is open to all
          bidders. The Property is either sold to a third-party bidder at the
          event or reverts back to the beneficiary (Mortgagee, Bank or Lender)
          as a Real Estate Owned (REO) Foreclosure. The sale must be publicly
          advertised and is conducted live or online. At the auction, the
          property is won by the highest bidder. The purchaser may also be
          responsible for any additional liens attached to the property. Please
          &nbsp;
          <a
            href='/lp/learn-more/foreclosure/before-auction#due-diligence'
            target='_blank'
            rel='noreferrer'
          >
            see information on how to conduct due diligence here.
          </a>
          &nbsp; If no bids exceed the bid placed by the lender, the property
          reverts.
        </p>
      ),
    },
    {
      elmId: 'tennessee_when_foreclosure_sales_occur',
      q: 'When and where do foreclosure sales occur?',
      a: (
        <p>
          The time and location of foreclosure sales can vary by county and
          depend on who is conducting the sale. For sales conducted by
          Auction.com, please note that some auctions may be held online or in
          person. Click on the link for the most up to date &nbsp;
          <a href='/calendar' target='_blank' rel='noreferrer'>
            sale calendar
          </a>
          &nbsp; For the most accurate and up-to-date details, refer to the
          Foreclosure Sale Notice, or visit our website at &nbsp;
          <a href='https://auction.com' target='_blank' rel='noreferrer'>
            www.auction.com
          </a>
        </p>
      ),
    },
    {
      elmId: 'tennessee_what_to_bring_to_foreclosure_sale',
      q: 'What do I need to bring to a foreclosure sale?  ',
      a: (
        <>
          <p>
            To register to bid at a live <b>IN-PERSON</b> auction, you must meet
            the following requirements with auction.com:
          </p>
          <ol>
            <li>Valid U.S. Government-Issued ID</li>
            <li>
              Cashier’s Check, for the full amount of your highest bid made out
              in your name.
            </li>
            <li>An active Auction.com account registered in your name</li>
          </ol>
          <p>
            To register to bid for an <b>ONLINE</b> auction, you must meet the
            following requirements:
          </p>
          <ol>
            <li>Valid U.S. Government-Issued ID</li>
            <li>
              Register and go through a verification process on our
              website,&nbsp;
              <a href='/' target='_blank' rel='noreferrer'>
                www.auction.com
              </a>
              &nbsp;
            </li>
            <li>
              Have full funds in the amount of your highest bid available at
              time of sale to be wired by 5:00PM on the day of sale.
            </li>
          </ol>
        </>
      ),
    },
    {
      elmId: 'tennessee_property_cancelled_or_postponed',
      q: 'What happens if a property is cancelled or postponed ?',
      a: (
        <>
          <p>
            The sale of a property may be postponed or canceled for various
            reasons prior to the start of bidding. There is no guarantee that a
            specific property will be brought to sale.
          </p>
          <p>
            For the most accurate and up-to-date details, refer to the
            Foreclosure Sale Notice, or visit our website at &nbsp;
            <a href='https://auction.com' target='_blank' rel='noreferrer'>
              www.auction.com
            </a>
          </p>
        </>
      ),
    },
    {
      elmId: 'tennessee_buyer_premium',
      q: 'Is a buyer’s premium added to the winning bid amount at a foreclosure sale?  ',
      a: (
        <p>
          No, a buyer’s premium does not apply for these specific sale events.
        </p>
      ),
    },
    {
      elmId: 'tennessee_online_liens',
      q: 'Will the Property be free and clear of all liens?',
      a: (
        <p>
          Properties will be sold “as is, where is,” with all faults and
          limitations. All prospective bidders are encouraged to conduct their
          own due diligence and investigate all matters relating to the
          Properties that they are interested in purchasing. It is recommended
          that you seek independent advice to perform your due diligence and to
          fully understand the foreclosure process and foreclosure sales in
          general prior to the sale. Doing your homework pays off! Some
          Properties may have information provided by Auction.com on the
          Property details page. It is your responsibility to do a title search
          and seek any needed advice from counsel prior to the sale.
        </p>
      ),
    },
    {
      elmId: 'tennessee_online_inspection',
      q: 'Can I inspect the Property?',
      a: (
        <p>
          No, as these Properties can be occupied, prospective bidders may not
          trespass on the Property, disturb the occupants or contact the
          borrowers to obtain information about the Property. However, detailed
          Property information for some Properties may be available for
          informational purposes only on the Property details page at&nbsp;
          <a href='https://auction.com' target='_blank' rel='noreferrer'>
            www.auction.com
          </a>
        </p>
      ),
    },
    {
      elmId: 'tennessee_online_winning_bidder',
      q: 'What happens after I win?',
      a: (
        <p>
          <b>Live in-person Auction:</b> Bidder must provide a Cashier’s Check
          or Certified Check for 20% of your highest intended bid, made out to
          Auction.com, LLC. The remaining amount must be received in 24 hours
          from sales time. <br /> <b>Online Auction:</b> After the closing of
          sale, a representative from Auction.com will contact you to finalize
          all paperwork and provide instructions for transferring funds, which
          must be received within 24 hours of the sale.
        </p>
      ),
    },
    {
      elmId: 'tennessee_online_deed_of_sale',
      q: 'Will I receive a deed of sale?',
      a: (
        <p>
          Yes, in Tennessee, the deed will be prepared and mailed by the
          attorney firm within 30 -60 days of the sale.
        </p>
      ),
    },
    {
      elmId: 'tennessee_online_foreclosure_redemption_period',
      q: 'Does TN have a foreclosure redemption period?  ',
      a: (
        <p>
          Typically not based on whether there was a waiver or not on the
          original loan. Please consult your real estate counsel or licensed
          professional for specific guidance.
        </p>
      ),
    },
  ]

  if (isTPSIllinois(listing)) return illinoisOnlineContents

  if (isTennessee(listing)) return tennesseeOnlineContents

  if (isSmartSale(listing) && isOfferContent) {
    return smartSaleOfferContents
  }

  if (isSmartSale(listing) && !isOfferContent) {
    return smartSaleAuctionContents
  }

  return isPrivateSeller(listing) && isOfferContent
    ? offerContents
    : noneOfferContents
}

const FaqsContent = () => {
  const { listing } = useListingContext()
  const [visibleIndex, setVisibleIndex] = useState<number>(-1)
  const handleClick = (titleProps: { index: number }) => {
    const { index } = titleProps
    setVisibleIndex(prevIndex => (prevIndex === index ? -1 : index))
  }
  const finalContents = getContents()
  return (
    <Accordion role='list'>
      {finalContents.map((item, index) => {
        const display = isFunction(item.condition)
          ? item.condition(listing)
          : true
        return (
          display && (
            <List.Item key={index}>
              <Accordion.Title
                index={index}
                onClick={() => handleClick({ index })}
                className={cx('title')}
              >
                <Icon
                  name={visibleIndex === index ? 'angle-up' : 'angle-down'}
                  iconStyle='light'
                  size='large'
                  className='u-fr'
                />
                <Text data-elm-id={`${item.elmId}_title`}>{item.q}</Text>
              </Accordion.Title>
              <Accordion.Content
                className={cx('content', 'u-ml-2')}
                active={visibleIndex === index}
              >
                <Text color='gray'>
                  <Icon
                    name='hand-point-right'
                    iconStyle='light'
                    size='large'
                    className='u-fl'
                  />
                  <div
                    className='u-ml-6 u-mr-6'
                    data-elm-id={`${item.elmId}_content`}
                  >
                    {item.a}
                  </div>
                </Text>
              </Accordion.Content>
              {index < finalContents.length - 1 && (
                <Divider className={cx('divider')} />
              )}
            </List.Item>
          )
        )
      })}
    </Accordion>
  )
}
const foreclosureFAQUrl = `/lp/foreclosure/`
const foreclosure_faq_url = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing']
) => {
  return `${foreclosureFAQUrl}${_.toLower(
    // @ts-ignore TODO:
    listing?.seller_property?.country_primary_subdivision
  )}${isTPSOhio(listing) ? '/?faq=online' : ''}`
}
const FAQLink = (
  listing: blueprint.AuctionBlueprintOnlineReactiveArgs['listing'],
  isOfferDisposition: boolean
) => {
  if (isSmartSale(listing) && isOfferDisposition) {
    return 'https://www.smartsale.com/buyer-guide/#faq'
  }
  return isNotFcl(listing)
    ? '/lp/learn-more/frequently-asked-questions/'
    : foreclosure_faq_url(listing)
}

const Faqs = () => {
  const { listing, segment } = useListingContext()
  const { featureFlags } = useApplicationContext()
  const isOfferDisposition = isOffer(segment, featureFlags)

  return (
    <SectionPanel elmId='faqs' title='Top FAQs' compact='top-only'>
      <Grid>
        <Grid.Column
          computer={!isOfferDisposition ? 10 : 16}
          tablet={!isOfferDisposition ? 9 : 16}
          mobile={16}
        >
          <FaqsContent />
          <div className='u-mt-6'>
            <a
              data-elm-id='see_more_faqs'
              href={FAQLink(listing, isOfferDisposition)}
              target='_blank'
              rel='noreferrer'
            >
              See more FAQs
            </a>
          </div>
        </Grid.Column>
        {!isOfferDisposition && (
          <Grid.Column computer={6} tablet={7} mobile={16} textAlign='center'>
            <AdvertisementInjection
              dataAdSpace={`PDP_FAQ_${isNotFcl(listing) ? 'REO' : 'TPS'}`}
            >
              <a
                data-elm-id='learn_more_reo'
                href={
                  isNotFcl(listing)
                    ? '/lp/learn-more/bank-owned/'
                    : '/lp/learn-more/foreclosure/before-auction/'
                }
                target='_blank'
                rel='noreferrer'
              >
                <img
                  src={HelpCenterImage}
                  alt='help center'
                  data-elm-id='faq_video_target'
                />
              </a>
            </AdvertisementInjection>
          </Grid.Column>
        )}
      </Grid>
    </SectionPanel>
  )
}

export default Faqs
export { Faqs }
